import React from "react";
import DispatchList from "./dispatchEntryList";
import NavHeightAdjust from "../../../../components/navbar/NavHeightAdjust";

const DispatchEntry = () => {
  return (
    <NavHeightAdjust>
      <DispatchList />
    </NavHeightAdjust>
  );
};

export default DispatchEntry;
